import t from"../../../utils/slug.js";import e from"../GA/utils/dataLayerPush.js";const o=e(({value:e})=>({content_id:t(e.text),content_type:"footer",event:"select_content",screenName:"footer"}));export{o as footerItemClick};
